// extracted by mini-css-extract-plugin
module.exports = {"homeLinks":"Home-module--homeLinks--NQqFE","tagline":"Home-module--tagline--Lv6m7"};